export default __webpack_public_path__ + "static/media/green-trane-BA-logo.2d605c9d.png";